import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up add-board" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "add-board-templates" }
const _hoisted_5 = { class: "add-board-template-text" }
const _hoisted_6 = {
  key: 0,
  class: "add-board-template-desc"
}
const _hoisted_7 = { class: "add-board-template-cols" }
const _hoisted_8 = {
  key: 1,
  class: "add-board-template-cols"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "add-board-template-text" }
const _hoisted_11 = { class: "add-board-template-name" }
const _hoisted_12 = {
  key: 0,
  class: "add-board-template-desc"
}
const _hoisted_13 = { class: "add-board-template-cols" }
const _hoisted_14 = {
  key: 1,
  class: "add-board-template-cols"
}
const _hoisted_15 = {
  key: 0,
  class: "add-board-manage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Name", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "add-board-name",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSlug())),
        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submit()), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.formData.Name]
      ]),
      (_ctx.otherTemplates.length || _ctx.canManageTemplates)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Start from", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", {
                class: _normalizeClass(_ctx.formData.TemplateID ? 'add-board-template' : 'add-board-template on')
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "add-board-template",
                  value: null,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.TemplateID) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.TemplateID]
                ]),
                _createElementVNode("span", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "add-board-template-name" }, "Default", -1)),
                  (_ctx.defaultTemplate && _ctx.defaultTemplate.Description)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.defaultTemplate.Description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultColumns, (col, ci) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: ci,
                        class: "add-board-template-chip",
                        style: _normalizeStyle('background:' + col.color)
                      }, _toDisplayString(col.name), 5))
                    }), 128))
                  ]),
                  (_ctx.defaultTemplate && _ctx.defaultTemplate.Tags.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultTemplate.Tags, (tag, ti) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: ti,
                            class: "add-board-template-tag",
                            style: _normalizeStyle('background:' + tag.color)
                          }, _toDisplayString(tag.name), 5))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherTemplates, (t) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: t.ID,
                  class: _normalizeClass(_ctx.formData.TemplateID == t.ID ? 'add-board-template on' : 'add-board-template')
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "add-board-template",
                    value: t.ID,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.TemplateID) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelRadio, _ctx.formData.TemplateID]
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(t.Name), 1),
                    (t.Description)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(t.Description), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Columns, (col, ci) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: ci,
                          class: "add-board-template-chip",
                          style: _normalizeStyle('background:' + col.color)
                        }, _toDisplayString(col.name), 5))
                      }), 128))
                    ]),
                    (t.Tags.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Tags, (tag, ti) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: ti,
                              class: "add-board-template-tag",
                              style: _normalizeStyle('background:' + tag.color)
                            }, _toDisplayString(tag.name), 5))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]),
            (_ctx.canManageTemplates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.manageTemplates()), ["prevent"]))
                  }, "Manage templates")
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Submit",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ])
  ]))
}